import { route } from '@/lang/ro/route'
import { common } from '@/lang/ro/common'
import { sidebar } from '@/lang/ro/sidebar'
import { navbar } from '@/lang/ro/navbar'
import { login } from '@/lang/ro/views/login'
import { logout } from '@/lang/ro/views/logout'
import { dashboard } from '@/lang/ro/views/dashboard'

import partners from '@/features/partners/lang/partners.json'
import documentDetails from '@/features/document-details/lang/document-details.json'
import contracts from '@/features/contracts/lang/contracts.json'
import acteAditionale from '@/features/acte-aditionale/lang/acte-aditionale.json'
import acteAditionaleGrupareContracte from '@/features/acte-aditionale-grupare-contracte/lang/acte-aditionale-grupare-contracte.json'
import grupareContracte from '@/features/grupare-contracte/lang/grupare-contracte.json'
import ofertaLicitatieAchizitie from '@/features/oferta-licitatie-achizitie/lang/oferta-licitatie-achizitie.json'
import licitatieAchizitie from '@/features/licitatie-achizitie/lang/licitatie-achizitie.json'
import mappingAdRoles from '@/features/mapping-ad-roles/lang/mapping-ad-roles.json'
import customFields from '@/features/campuri-personalizate/lang/custom-fields.json'
import contractTypes from '@/features/contract-types/lang/contract-types.json'
import configurareAplicatie from '@/features/configurare-aplicatie/lang/configurare-aplicatie.json'
import accesSecuritate from '@/features/acces-securitate/lang/acces-securitate.json'
import profile from '@/features/profile/lang/profile.json'
import users from '@/features/users/lang/users.json'
import notificationSubscription from '@/features/notification-subscription/lang/notification-subscription.json'
import userNotifications from '@/features/user-notifications/lang/user-notifications.json'

export const ro = {
  route,
  common,
  sidebar,
  navbar,
  view: {
    login,
    logout,
    dashboard
  },
  partners,
  documentDetails,
  contracts,
  acteAditionale,
  acteAditionaleGrupareContracte,
  grupareContracte,
  ofertaLicitatieAchizitie,
  licitatieAchizitie,
  mappingAdRoles,
  customFields,
  contractTypes,
  configurareAplicatie,
  accesSecuritate,
  users,
  profile,
  notificationSubscription,
  userNotifications,

  // vue vee validation messages
  validation: {
    required: 'Câmpul este necesar',
    max: 'Câmpul nu poate depăși {length} caractere',
    min: 'Câmpul trebuie să aibă un minim de {length} caractere',
    numeric: 'Câmpul acceptă doar valori numerice',
    min_value: 'Valoarea minimă acceptată este {min}',
    max_value: 'Valoarea maximă acceptată este {max}',
    default: 'Câmpul nu este valid.'
  }
}
